module.exports = __webpack_public_path__ + "media/wind.b215b58e.mp3";